<template>
    <div>
        <page-title>{{ $t('tag_groups.list_page_title') }}</page-title>
        <taggroup-table ref="table" @company-filter="companyFilter = $event">
            <template v-slot:actions>
                <create-button
                    :route-name="routeType.TAG_GROUP_CREATE"
                    tabbed
                ></create-button>
            </template>
        </taggroup-table>
    </div>
</template>

<script>
import PageTitle from '@/components/layout/components/pageTitle'
import routeType from '@/router/routeType'
import TaggroupTable from '@/components/pages/tagGroups/Table'
import CreateButton from '@/components/form/Actions/CreateButton'
import AuthMixin from '@/components/mixins/AuthMixin'

export default {
    components: {
        PageTitle,
        TaggroupTable,
        CreateButton,
    },
    mixins: [AuthMixin],
    data() {
        return {
            routeType,
            companyFilter: null,
        }
    },
}
</script>
